<h1>Pallet Reclassification</h1>

<p *ngIf="addForm.disabled">
  <p-message severity="warn" text="Reclassifications cannot be added because the current shift is closed." closable="false"></p-message>
</p>

<p *ngIf="anyItemsAreClosed">
  <p-message severity="warn" text="Only the Reference number may be edited when the assigned shift is closed." closable="false"></p-message>
</p>

<p-card class="p-grid p-col-7 p-xl-7">
  <div class="p-grid">
    <div class="p-col-12 p-xl-12">
      <p-table [value]="palletReclassificationItems" dataKey="id" [paginator]="true" [rows]="10" [rowTrackBy]="rowTrackBy">
        <ng-template pTemplate="header">
          <tr>
            <th>Operation</th>
            <th>From Product</th>
            <th>To Product</th>
            <th class="thQuantityColumn">Quantity</th>
            <th class="thRefNumColumn">Reference <br> Number</th>
            <th class="thQuantityColumn">Delete</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
          <tr [pEditableRow]="rowData" class="vertAlign">
            <td>
              <p-dropdown [options]="subinventories" placeholder="-- None --" [(ngModel)]="rowData.siteSubinventoryId"
                [ngModelOptions]="{standalone: true}" name="siteSubinventoryId" [required]="true" appendTo="body"
                (onChange)="onChangePalletReclassificationField(rowData)" [filter]="true" [resetFilterOnHide]="true"
                (onBlur)="cloneRowData(rowData)" [disabled]="loadingPost || loadingDelete !== null || rowData.workedShiftStatus === ShiftStatus.Closed">
              </p-dropdown>
            </td>
            <td>
              <p-dropdown [options]="getProductList(rowData.siteSubinventoryId) | async" placeholder="-- None --" [(ngModel)]="rowData.fromProductId"
                [ngModelOptions]="{standalone: true}" name="fromProductId" [required]="true" appendTo="body"
                (onChange)="onChangePalletReclassificationField(rowData)" [filter]="true" [resetFilterOnHide]="true"
                (onBlur)="cloneRowData(rowData)" [disabled]="loadingPost || loadingDelete !== null || rowData.workedShiftStatus === ShiftStatus.Closed">
              </p-dropdown>
            </td>
            <td>
              <p-dropdown [options]="getProductList(rowData.siteSubinventoryId) | async" placeholder="-- None --" [(ngModel)]="rowData.toProductId"
                [ngModelOptions]="{standalone: true}" name="toProductId" [required]="true" appendTo="body"
                (onChange)="onChangePalletReclassificationField(rowData)" [filter]="true" [resetFilterOnHide]="true"
                (onBlur)="cloneRowData(rowData)" [disabled]="loadingPost || loadingDelete !== null || rowData.workedShiftStatus === ShiftStatus.Closed">
              </p-dropdown>
            </td>
            <td>
              <input pInputText type="text" [(ngModel)]="rowData.quantity"  name="quantity"
                [ngModelOptions]="{standalone: true}" required lib-numeric [decimals]="2"
                (change)="onChangePalletReclassificationField(rowData)" (focus)="cloneRowData(rowData)" [disabled]="loadingPost || loadingDelete !== null || rowData.workedShiftStatus === ShiftStatus.Closed">
            </td>
            <td>
              <input pInputText type="text" [(ngModel)]="rowData.referenceNumber"  name="referenceNumber"
                [ngModelOptions]="{standalone: true}" required maxlength="20"
                (change)="onChangePalletReclassificationField(rowData)" (focus)="cloneRowData(rowData)" [disabled]="loadingPost || loadingDelete !== null">
            </td>
            <td>
              <confirmation-button [iconsOnly]="true" actionIcon="pi pi-times" actionText="Delete"
                confirmIcon="pi pi-times" confirmText="Delete" cancelIcon="pi pi-minus-circle" cancelText="Cancel"
                (actionConfirmed)="onPalletReclassificationRowDelete(rowData)" [disabled]="loadingPost || loadingDelete !== null || rowData.workedShiftStatus === ShiftStatus.Closed" [working]="loadingDelete === rowData.id">
              </confirmation-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="5" class="centered">
              No data available
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer" let-rowData>
          <tr [formGroup]="addForm">
            <td>
              <p-dropdown [options]="subinventories" [required]="true" [filter]="true" [editable]="false" [resetFilterOnHide]="true" appendTo="body"
                placeholder="-- Select Operation --" inputId="siteSubinventoryId" class="form-control" name="siteSubinventoryId" formControlName="siteSubinventoryId">
              </p-dropdown>
              <error-block [field]="addForm.get('siteSubinventoryId')" [messages]="{
                  required: 'Operation is required.'
                }">
              </error-block>
            </td>
            <td>
              <p-dropdown [options]="formProducts | async" [required]="true" [filter]="true" [editable]="false" [resetFilterOnHide]="true" appendTo="body"
                placeholder="-- Select Product --" inputId="fromProductId" class="form-control" name="fromProductId" formControlName="fromProductId">
              </p-dropdown>
              <error-block [field]="addForm.get('fromProductId')" [messages]="{
                  required: 'From Product is required.'
                }">
              </error-block>
            </td>
            <td>
              <p-dropdown [options]="formProducts | async" [required]="true" [filter]="true" [editable]="false" [resetFilterOnHide]="true" appendTo="body"
                placeholder="-- Select Product --" inputId="toProductId" class="form-control" name="toProductId" formControlName="toProductId">
              </p-dropdown>
              <error-block [field]="addForm.get('toProductId')" [messages]="{
                  required: 'To Product is required.'
                }">
              </error-block>
            </td>
            <td>
              <input type="text" lib-numeric pInputText id="quantity" required name="quantity" class="form-control" formControlName="quantity"/>
              <error-block [field]="addForm.get('quantity')" [messages]="{
                  required: 'Quantity is required.'
                }">
              </error-block>
            </td>
            <td>
              <input type="text" pInputText id="referenceNumber" name="referenceNumber" class="form-control" required maxlength="20" formControlName="referenceNumber"/>
              <error-block [field]="addForm.get('referenceNumber')" [messages]="{
                  required: 'Reference Number is required.',
                  maxLength: 'Reference Number must be less than 20 characters.'
                }">
              </error-block>
            </td>
            <td>
              <button pButton type="button"
                  [disabled]="loadingPost"
                  [icon]="loadingPost ? 'pi pi-spin pi-spinner' : 'pi pi-plus'"
                  (click)="savePalletReclassification();"
                  label="Add"
                  class="addBtn"
                  [ngClass]="{ 'p-state-disabled': !addForm.valid }"
                  [disabled]="addForm.disabled">
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-card>
